// JS port of ADwise content/rules.py::match_score
// Tek reklamı bir profil karşısında puanlar. Server-side scoring rules'a SADIK
// kalmalı, aksi halde simülasyon yanlış sonuç verir.

import { AGE_BRACKETS } from "./constants.js";

const _BRACKET_INDEX = Object.fromEntries(AGE_BRACKETS.map((b, i) => [b, i]));

const W_AGE = 0.4;
const W_NEIGHBOR = 0.2;
const W_GENDER = 0.3;
const W_GROUP = 0.5;
const NO_TARGET_BASE = 0.3;

function hasNoTarget(ad) {
  return (
    !(ad.age_brackets && ad.age_brackets.length) &&
    !(ad.genders && ad.genders.length) &&
    !(ad.group_types && ad.group_types.length)
  );
}

export function scoreAd(ad, profile) {
  if (hasNoTarget(ad)) {
    return {
      raw_score: NO_TARGET_BASE,
      age_match: "no_target",
      gender_match: false,
      group_match: "no_target",
      priority: 5,
      priority_mult: 1.0,
    };
  }

  let score = 0;
  let age_match = "none";

  if ((ad.age_brackets || []).includes(profile.age)) {
    score += W_AGE;
    age_match = "exact";
  } else {
    const idx = _BRACKET_INDEX[profile.age];
    if (idx !== undefined) {
      for (const tb of ad.age_brackets || []) {
        const ti = _BRACKET_INDEX[tb];
        if (ti !== undefined && Math.abs(idx - ti) === 1) {
          age_match = "neighbor";
          score += W_NEIGHBOR;
          break;
        }
      }
    }
  }

  const gender_match =
    profile.gender &&
    (ad.genders || []).map((g) => g.toLowerCase()).includes(profile.gender.toLowerCase());
  if (gender_match) score += W_GENDER;

  let group_match;
  if (!(ad.group_types || []).length) {
    score += W_GROUP;
    group_match = "no_target_group";
  } else if (profile.group_type && ad.group_types.includes(profile.group_type)) {
    score += W_GROUP;
    group_match = "exact";
  } else {
    group_match = "none";
  }

  if (score === 0) {
    return {
      raw_score: 0,
      age_match,
      gender_match,
      group_match,
      priority: ad.priority ?? 5,
      priority_mult: 0,
    };
  }

  const priority = ad.priority ?? 5;
  const priority_mult = 0.3 + 0.7 * (priority / 10.0);
  const raw_score = Math.round(score * priority_mult * 10000) / 10000;

  return { raw_score, age_match, gender_match, group_match, priority, priority_mult };
}

export function rankAds(allAds, profile) {
  return allAds
    .map((ad) => ({ ad, breakdown: scoreAd(ad, profile) }))
    .sort((a, b) => b.breakdown.raw_score - a.breakdown.raw_score);
}

export function priorityDescription(p) {
  if (p <= 3) return { label: "Düşük", note: "Aynı kitleye gelen başka reklamlardan daha az çıkar" };
  if (p <= 6) return { label: "Normal", note: "Standart frekansta çıkar" };
  if (p <= 8) return { label: "Yüksek", note: "Aynı kitleye normalden ~2x daha sık çıkar" };
  return { label: "Çok yüksek", note: "Aynı kitleye normalden ~3x daha sık çıkar — en üst öncelik" };
}
